import { allOperatorTemplates } from './filterSpecConfig'

const handleQueryDsl = (q) => {
  if (!Array.isArray(q.value) || q.queryType[0] === 'lnglat') {
    const { slug, value, queryType, id, tbId } = q
    // 从field中找到queryType的模板生成器
    return allOperatorTemplates[queryType](slug, id, value, tbId)
  }
  return {
    queryType: q.queryType === 'notInList' ? 'and' : 'or', // not应该是and
    childQueries: q.value.map((item) => {
      const { slug, queryType, id, tbId } = q
      return allOperatorTemplates[queryType](slug, id, item, tbId)
    }),
  }
}

export const createQueryDsl = (filters = {}, order = []) => {
  const { logicType, queries = [], childQueries } = filters
  const props = {}
  if (order && order.length) {
    const arr = order.map((x) => {
      return { desc: x.order === 'desc', slug: x.slug }
    })
    // const obj = order[0]
    props.orders = arr
  }

  if (!childQueries) {
    return {
      query: {
        queryType: logicType || 'and',
        childQueries: queries.map((q) => {
          console.log('parsefilter', q, typeof q)
          if (q.logicType) {
            // 有默认筛选
            return {
              queryType: q.logicType || 'or',
              childQueries: q.queries.map((q1) => {
                if (q1.logicType) {
                  return {
                    queryType: q1.logicType || 'or',
                    childQueries: q1.queries.map((q11) => {
                      return handleQueryDsl(q11)
                    }),
                  }
                }
                return handleQueryDsl(q1)
              }),
            }
          }
          return handleQueryDsl(q)
        }),
      },
      ...props,
    }
  }
  return {
    query: {
      queryType: logicType,
      childQueries,
    },
    ...props,
  }
}
